module.exports = __webpack_public_path__ + "static/media/logo.f1cd1807.png";